import { createGlobalStyle } from 'styled-components';

const StepOneStyles = createGlobalStyle`
.step1-page {
  background: #f6f6f6;
  height: 100%;
  overflow-y: auto;
}

.step1-page .container-fluid {
  position: relative;
  padding: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.step1-page .step1-container {
  background: #f6f6f6;
  padding: 132px 20px 20px;
  position: relative;
  flex: 1;
  position: relative;
  margin-top: -132px;
  z-index: 1;
  flex: 1;
  overflow-y: auto;
}

.step1-page .preview {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.step1-page .preview::before {
  content: "";
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

.step1-page .preview > * {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.step1-page .content {
  padding: 0px;
}

.step1-page .content .left {
  margin-bottom: 30px;
}

.step1-page .content .left > p {
  text-align: center;
  color: #6f7072;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin: 32px auto 24px;
  position: relative;
}

.step1-page .content .right {
  padding-bottom: 92px;
}

.step1-page .content .camera-wrapper {
  width: 100%;
  height: 0;
  padding-top: 56.25%;
  position: relative;
}

.step1-page .content .camera-wrapper .camera-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.step1-page .content .camera-wrapper .camera-inner .camera-inner-content {
  --b: 2px; /* thickness of the border */
  --c: #00d764; /* color of the border */
  --w: 32px; /* width of border */
  --r: 16px; /* radius */

  padding: var(--b); /* space for the border */
  position: relative;
  /*Irrelevant code*/
  box-sizing: border-box;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding: 12px;
}

.step1-page
  .content
  .camera-wrapper
  .camera-inner
  .camera-inner-content::before {
  content: "";
  position: absolute;
  inset: 0;
  background: var(--c, #00d764);
  padding: var(--b);
  border-radius: var(--r);
  -webkit-mask: linear-gradient(0deg, #000 calc(2 * var(--b)), #0000 0) 50%
      var(--b) / calc(100% - 2 * var(--w)) 100% repeat-y,
    linear-gradient(-90deg, #000 calc(2 * var(--b)), #0000 0) var(--b) 50%/100%
      calc(100% - 2 * var(--w)) repeat-x,
    linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: destination-out;
  mask-composite: exclude;
}

.step1-page .content .camera-wrapper .camera-inner .video-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
}

/*
.step1-page .content .camera-wrapper .camera-inner .video-wrapper * {
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
}
*/

.step1-page .content .captured-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 24px;
}

.step1-page .content .captured-list .captured-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 10px;
  border: 1px dashed #a0a0a0;
  border-radius: 12px;
  position: relative;
  flex: 1;
  aspect-ratio: 7/4;
  max-width: 225px;
}
.step1-page .content .captured-list .captured-item.successful {
  border: 1px dashed #00d764;
}

.step1-page .content .captured-list .captured-item.successful .icon-checked {
  display: flex;
}

// .step1-page .content .captured-list .captured-item > img {
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   top: 0;
//   left: 0;
//   z-index: 1;
//   border-radius: 12px;
//   overflow: hidden;
// }

.step1-page .content .captured-list .captured-item .icon-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  img.img-capture {
    height: 100%;
  }
}

.step1-page .content .captured-list .captured-item > img[src=""] {
  display: none;
}

.step1-page
  .content
  .captured-list
  .captured-item
  > img:not([src=""])
  ~ .capture-item-placeholder {
  opacity: 0;
}

.step1-page .content .captured-list .captured-item .capture-item-placeholder {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ccc;
  justify-content: center;
  padding: 8px;
  font-size: 12.8px;

  span.text-danger {
    color: #c21b17
  }

  // img.img-capture {
  //   position: absolute;
  //   width: 100%;
  //   height: 100%;
  //   top: 0;
  //   left: 0;
  //   z-index: 1;
  //   border-radius: 12px;
  //   overflow: hidden;
  // }
}

.step1-page
    .content
    .right
    .captured-list
    .captured-item
    .capture-item-placeholder
    svg
    path {
    fill: #c21b17;
  }

.step1-page .content .captured-list .captured-item .icon-checked {
  border-radius: 50%;
  background-color: #ffffff;
  position: absolute;
  right: -12px;
  top: -12px;
  z-index: 2;
  display: none;
  align-items: center;
  justify-content: center;
}

.step1-page .content .page-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 0px 20px;
  display: none;
}
.step1-page .content .left .page-footer {
  display: none;
}
.step1-page .content .right .page-footer {
  display: block;
  position: absolute;
  bottom: 20px;
  left: 20px;
  right: 20px;
  width: auto;
  padding: 0;
  z-index: 2;
}

.step1-page .content .page-footer a {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00d764;
  margin-bottom: 12px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
}
.step1-page .content .page-footer > a .icon {
  margin-right: 10px;
}

.step1-page .content .page-footer button {
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-decoration: none;
  padding: 12px 20px;
}

.step1-page .content .page-footer button a {
  margin: 0;
  color: inherit;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}

@media screen and (min-width: 576px) {
  .step1-page .step1-container {
    padding: 122px 70px 0px;
    position: relative;
    margin-top: -122px;
    z-index: 1;
    height: 100%;
  }

  .step1-page .content .right {
    display: flex;
    flex-direction: column;
  }

  .step1-page .content .captured-list .captured-item .capture-item-placeholder,
  .step1-page .content .captured-list .captured-item .capture-item-placeholder .ant-upload {
    font-size: 16px;
  }

  .step1-page
    .content
    .right
    .captured-list
    .captured-item
    .capture-item-placeholder
    br {
    display: none;
  }

  .step1-page .content .left .page-footer {
    display: none;
  }
  
  .step1-page .content .right .page-footer {
    margin-top: 48px;
    display: block;
    position: relative;
    width: auto;
    left: 0px;
  }
}

@media screen and (min-width: 769px) {
  .step1-page .preview {
    display: none;
  }
  .step1-page .container-fluid {
    min-height: unset;
  }
  .step1-page .step1-container {
    padding: 182px 70px 0px;
    margin-top: -182px;
  }

  .step1-page .content {
    display: flex;
    gap: 24px;
  }

  .step1-page .content .left {
    flex: 94;
    position: relative;
  }
  .step1-page .content .right {
    flex: 45;
  }

  .step1-page .content .left > p {
    color: #6f7072;
  }
  .step1-page .content .left .rotate-btn {
    display: none;
  }

  .step1-page .content .right .captured-list {
    flex-direction: column;
    padding: 12px 20px;
    margin-top: 104px;
  }

  .step1-page .content .right .captured-list .captured-item {
    width: 100%;
    align-items: center;
    max-width: unset;
  }

  .step1-page
    .content
    .right
    .captured-list
    .captured-item
    .capture-item-placeholder {
    width: 100%;
    // color: #c21b17;
    color: #ccc;
  }

  .step1-page
    .content
    .right
    .captured-list
    .captured-item
    .capture-item-placeholder
    svg
    path {
    fill: #c21b17;
  }

  .step1-page .content .left .page-footer {
    display: block;
    margin-top: 12px;
  }
  .step1-page .content .right .page-footer {
    padding: 0px;
    position: relative;
    margin-top: 42px;
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .container-fluid {
    max-width: 100%;
  }
}
  
`;

export default StepOneStyles;
